// 今日餐品营养 - 详情
import { useState, useEffect } from "react"
import { Spin } from "antd"
import TitleComponent from "@/components/sc/TitleComponent"
import PageFooter from "@/components/sc/PageFooter"
import api from "@/net/api"
import ReactEcharts from "echarts-for-react"

import ImgProduct from "@/assets/img/icon_product.png"
import ImgNutritionAnalasis from "@/assets/img/product-nutrition-analasis.png"
import ImgNutritionGroup from "@/assets/img/product-nutrition-group.png"

import "./info.less"

export default function Info(props) {
	const [info, setInfo] = useState(null)
	useEffect(() => {
		getInfo()
	}, [])
	async function getInfo() {
		try {
			let d = await api.productNourishment_getLibraryById({ id: props.id })

			d.absPicUrls_ = [d.absPic]

			d.n_ = d
			setInfo(d)
			initChart(d.n_)
			setNutritionGroups(d.n_)
			setNutritionAnalasisList(d.n_)
		} catch(e) {
			console.log(e)
		}
	}

	const [currentImageIndex, setCurrentImageIndex] = useState(0)
	function onClickImg(i) {
		if (i == currentImageIndex) {
			return
		}
		setCurrentImageIndex(i)
	}

	// ----------------------------------------------------------------------
	const [useKa, setUseKa] = useState(false)
	function toggleUseKa() {
		let value = info.n_.energyValue || 0
		let max = 5000
		if (!useKa) {
			if (info.n_.energyUnit == "KJ") {
				value = Kj2Kka(value)
			}
			max = Kj2Kka(max)
		} else {
			if (info.n_.energyUnit != "KJ") {
				value = Kka2Kj(value)
			}
		}
		value = value.toFixed(1)

		let newOptiton = {...chartOption}
		newOptiton.series = [...chartOption.series]
		newOptiton.series[1] = {...chartOption.series[1]}
		newOptiton.series[1].data = [{ value }]
		newOptiton.series[1].max = max
		newOptiton.series[2] = {...chartOption.series[1]}
		newOptiton.series[2].data = [{ value }]
		newOptiton.series[2].max = max
		setChartOption(newOptiton)

		setUseKa(!useKa)
	}
	// 1千焦 == 0.2389大卡
	function Kj2Kka(value) {
		return value * 0.2389
	}
	function Kka2Kj(value) {
		return value / 0.2389
	}

	// ----------------------------------------------------------------------
	// 业务: 规则：能量值、蛋白质、脂肪、碳水化合物，判定低、中、高的依据均适用“18-50营养标准”基准表的38%
	const [analasisList, setAnalasisList] = useState(() => {
		let a = [
			{ label: "蛋白质", value: 0, left: 0, background: "", start: 25, end: 30.01 },
			{ label: "脂肪", value: 0, left: 0, background: "", start: 26, end: 60 },
			{ label: "碳水化合物", value: 0, left: 0, background: "", start: 120, end: 300 },
		]
		const ratio = 0.38
		a.forEach(item => {
			item.start *= ratio
			item.end *= ratio
		})
		return a
	})
	function setNutritionAnalasisList(d) {
		let list = [...analasisList]
		list[0].current = d.protein || 0
		list[1].current = d.axunge || 0
		list[2].current = d.carbohydrate || 0

		list.forEach(item => {
			item.label = item.label
			item.value = item.current.toFixed(1)
			// 0-150 151-300 300-460
			let a = item
			if (a.current < a.start) {
				item.left = (a.current / a.start) * 150
				item.background = "#fec640"
			} else if (a.current > a.end) {
				item.left = (a.current - a.end) / (a.end - a.start) * 150 + 300
				item.background = "#ff5a5a"
			} else {
				item.left = (a.current - a.start) / (a.end - a.start) * 150 + 151
				item.background = "#00cca0"
			}
			if (item.left > 460) {
				item.left = 460
			}
			item.left += "px"
		})
		setAnalasisList(list)
	}

	// ----------------------------------------------------------------------
	const [groups, setGroups] = useState([])
	function setNutritionGroups(d) {
		const nutrition_map = {
			energyValue: ["能量", "KJ"],
			protein: ["蛋白质", "g"],
			axunge: ["脂肪", "g"],
			saturated: ["饱和脂肪酸", "g"],
			cholesterol: ["胆固醇", "mg"],
			carbohydrate: ["碳水化合物", "g"],
			dietaryFiber: ["膳食纤维", "g"],
			vitaminA: ["维生素A", "ug"],
			vitaminB1: ["维生素B1", "mg"],
			vitaminB2: ["维生素B2", "mg"],
			vitaminB6: ["维生素B6", "mg"],
			vitaminB12: ["维生素B12", "ug"],
			vitaminC: ["维生素C", "mg"],
			vitaminD: ["维生素D", "ug"],
			vitaminE: ["维生素E", "mg"],
			vitaminK: ["维生素K", "ug"],
			niacin: ["烟酸", "mg"],
			folic: ["叶酸", "ug"],
			pantothenic: ["泛酸", "mg"],
			biotin: ["生物素", "ug"],
			choline: ["胆碱", "mg"],
			calcium: ["钙", "mg"],
			phosphorus: ["磷", "mg"],
			potassium: ["钾", "mg"],
			sodium: ["钠", "mg"],
			magnesium: ["镁", "mg"],
			iron: ["铁", "mg"],
			zinc: ["锌", "mg"],
			iodine: ["碘", "ug"],
			selenium: ["硒", "ug"],
			copper: ["铜", "mg"],
			fluorine: ["氟", "mg"],
			chromium: ["铬", "ug"],
			manganese: ["锰", "mg"],
			molybdenum: ["钼", "ug"],
			salt: ["盐", "g"],
			oil: ["油", "g"],
			cereal: ["谷薯类", "g"],
			vegetable: ["蔬菜类", "g"],
			fruits: ["水果类", "g"],
			dairy: ["奶制品", "g"],
			soybean: ["大豆坚果", "g"],
			meat: ["肉禽蛋鱼", "g"],
		}

		let list = [
			{
				name: "营养素",
				keys: ["protein", "axunge", "cholesterol", "carbohydrate", "dietaryFiber"],
			},
			{
				name: "维生素",
				keys: [
					"vitaminA", "vitaminB1", "vitaminB2", "vitaminB6", "vitaminB12", "vitaminC", "vitaminD",
					"vitaminE", "vitaminK", "niacin", "folic", "pantothenic", "biotin", "choline",
				],
			},
			{
				name: "矿物质",
				keys: [
					"calcium", "phosphorus", "potassium", "sodium", "magnesium", "iron", "zinc",
					"iodine", "selenium", "copper", "fluorine", "chromium", "manganese", "molybdenum",
				],
			},
			{
				name: "膳食宝塔",
				keys: [
					"salt", "oil", "cereal", "vegetable", "fruits", "dairy", "soybean", "meat",
				],
			},
		]
		list.forEach(g => {
			g.list = []
			g.keys.forEach(k => {
				let item = nutrition_map[k]
				if (!item) {
					return
				}
				if (d[k] == undefined) {
					return
				}
				g.list.push({
					label: item[0],
					value: d[k] + item[1],
				})
			})
		})
		list = list.filter(g => g.list.length > 0)
		setGroups(list)
	}

	// ----------------------------------------------------------------------
	// echarts
	const [chartOption, setChartOption] = useState({})
	function initChart(d) {
		let option = {
			series: [
				{
					type: 'gauge',
					center: ['50%', '60%'],
					radius: '99%',
					startAngle: 220,
					endAngle: -40,
					min: 0,
					pointer: {
						show: false
					},
					axisLine: {
						lineStyle: {
							color: [[1, '#eee']],
							width: 2
						}
					},
					axisTick: {
						show: false
					},
					splitLine: {
						show: false
					},
					axisLabel: {
						show: false
					},
					title: {
						show: false
					},
					detail: {
						show: false
					}
				},
				{
					type: 'gauge',
					center: ['50%', '60%'],
					startAngle: 220,
					endAngle: -40,
					min: 0,
					max: 5000,
					splitNumber: 12,
					itemStyle: {
						color: '#00cca0'
					},
					progress: {
						show: true,
						width: 30
					},
					pointer: {
						show: false
					},
					axisLine: {
						lineStyle: {
							width: 30
						}
					},
					axisTick: {
						distance: -60,
						splitNumber: 5,
						length: 15,
						lineStyle: {
							width: 3,
							color: '#dedede'
						}
					},
					splitLine: {
						show: false,
						distance: -52,
						length: 14,
						lineStyle: {
							width: 3,
							color: '#999'
						}
					},
					axisLabel: {
						show: false
					},
					anchor: {
						show: false
					},
					title: {
						show: false
					},
					detail: {
						valueAnimation: true,
						width: '60%',
						lineHeight: 40,
						borderRadius: 8,
						offsetCenter: [0, '0%'],
						fontSize: 60,
						fontWeight: 'bolder',
						formatter: '{value}',
						color: 'inherit'
					},
					data: [
						{
							value: 20
						}
					]
				},
				{
					type: 'gauge',
					center: ['50%', '60%'],
					startAngle: 200,
					endAngle: -20,
					min: 0,
					max: 5000,
					itemStyle: {
						color: 'transparent'
					},
					progress: {
						show: true,
						width: 10
					},
					pointer: {
						show: false
					},
					axisLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					splitLine: {
						show: false
					},
					axisLabel: {
						show: false
					},
					detail: {
						show: false
					},
					data: [
						{
							value: 20
						}
					]
				}
			]
		}
		let value = d.energyValue || 0
		if (d.energyUnit != "KJ") {
			value = Kka2Kj(value)
		}
		value = value.toFixed(1)

		option.series[1].data = [{ value }]
		option.series[2].data = [{ value }]
		setChartOption(option)
	}

	// ----------------------------------------------------------------------
	return <div className="pages_main_product_info">
		<TitleComponent title="今日餐品营养" />

		<div className="body">
			<div className="main-info">
			{info &&
			<>
				<img className="info-img" src={ info.absPicUrls_[currentImageIndex] } />
				<div className="info-right">
					<div className="info-title">{ info.name }</div>
					<div className="info-mass">单份质量: <span className="info-mass-value">100g</span></div>
					<div className="info-imgs">
					{info.absPicUrls_.map((img, i) =>
						<div className="info-imgs-item" key={i} onClick={() => onClickImg(i)}>
							<img className="img-item" src={img} />
							{i == currentImageIndex &&
							<div className="img-item-current">当前</div>
							}
						</div>
					)}
					</div>
				</div>
			</>
			}
			</div>

			<div className="stat-graph">
				<div className="graph-top-bg"></div>
				{info
				? <div className="graph-graph">
					<div className="graph-energy">
						<div className="graph-top">
							<div className="graph-title">
								<img className="graph-title-img" src={ImgProduct} />
								<div className="graph-title-text">能量值</div>
							</div>
							<div className="energy-switch" onClick={() => toggleUseKa()}>
								<div className={"switch-item " + (useKa ? "" : "switch-item-current")}>千焦</div>
								<div className={"switch-item " + (useKa ? "switch-item-current" : "")}>大卡</div>
							</div>
						</div>
						<ReactEcharts option={chartOption} style={{ width: "350px", height: "350px", margin: "0 auto" }} />
					</div>
					<div className="graph-analasis">
						<div className="graph-title">
							<img className="graph-title-img" src={ImgNutritionAnalasis} />
							<div className="graph-title-text">摄入营养素分析</div>
						</div>
						<div className="a-list">
						{analasisList.map((item, i) =>
							<div className="a-item" key={i}>
								<div className="a-item-name">{ item.label }</div>
								<div className="bar">
									<div className="bar-low">
										<div className="bar-text">偏低</div>
									</div>
									<div className="bar-normal">
										<div className="bar-text">正常</div>
									</div>
									<div className="bar-high">
										<div className="bar-text">偏高</div>
									</div>

									<div className="bar-dot" style={{ left: item.left, background: item.background }}>
										<div className="bar-dot-a">
											<div className="bar-dot-text">{ item.value }{ item.unit || "g" }</div>
										</div>
									</div>
								</div>
							</div>
						)}
						</div>
					</div>
				</div>
				: <div className="graph-graph loading">
					<Spin />
				</div>
				}
			</div>

			<div className="stat-other">
				<div className="other-top-bg"></div>
				<div className="other-other">
					<div className="other-inner">
					{(groups.length > 0) &&
						<>
							<div className="inner-title">
								<img className="inner-title-img" src={ImgProduct} />
								<div className="inner-title-text">营养维生矿物质</div>
							</div>
							<div className="inner-groups">
							{groups.map((group, i) =>
								<div className="group-item" key={i}>
									<div className="group-corner">
										<img className="group-corner-bg" src={ImgNutritionGroup} />
										<div className="group-title">{group.name}</div>
									</div>
									<div className="nutri-list">
									{group.list.map((item, j) =>
										<div className="nutri-item" key={j}>
											<div className="nutri-item-label">{item.label}</div>
											<div className="nutri-item-value">{item.value}</div>
										</div>
									)}
									</div>
								</div>
							)}
							</div>
						</>
					}
					</div>
					<PageFooter style={{ color: "#747474", marginTop: "26px" }} />
				</div>
			</div>
		</div>
	</div>
}
